import { ProducerUserTypesEnumSchema } from '@eigtech/auth0-types';
import { z } from 'zod';
import { PortalEntityTypeSchema } from '../base/portal.js';
import { PortalUserSchema } from '../base/user.js';
import { PortalsServiceEventBaseSchema, portalsServiceEventType } from './service.js';
import { PortalZoneSchema } from '../base/zones.js';
const portalUserEventType = (eventName) => portalsServiceEventType('user', eventName);
export const PortalUserEventSchema = PortalsServiceEventBaseSchema.merge(z.object({
    type: portalUserEventType(),
    user: z.unknown().optional(),
}));
export const PortalUserCreatedEventSchema = PortalUserEventSchema.merge(z.object({
    type: portalUserEventType('created'),
    user: PortalUserSchema.merge(z.object({
        entityType: PortalEntityTypeSchema.optional(),
        userType: ProducerUserTypesEnumSchema.optional(),
        zone: PortalZoneSchema.optional(),
    })),
}));
export const PortalUserUpdatedEventSchema = PortalUserEventSchema.merge(z.object({
    type: portalUserEventType('updated'),
    user: PortalUserSchema,
}));
export const PortalUserDeletedEventSchema = PortalUserEventSchema.merge(z.object({
    type: portalUserEventType('deleted'),
    user: PortalUserSchema,
}));
export const PortalUserRestoredEventSchema = PortalUserEventSchema.merge(z.object({
    type: portalUserEventType('restored'),
    user: PortalUserSchema,
}));
